import React from 'react'
import Box from '@mui/material/Box'
import { TOUCH_MIN } from 'core/theme.tokens'

interface FilterToolbarProps {
  children: React.ReactNode
}

export const FilterToolbar: React.FC<FilterToolbarProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
        mb: 2,
        '& .MuiButton-root, & .MuiIconButton-root, & .MuiChip-root, & .MuiFormControl-root': {
          minHeight: { xs: TOUCH_MIN, sm: 'auto' },
        },
      }}
    >
      {children}
    </Box>
  )
}
